<template>
  <b-modal :id="id" :title="$t('dharma-application-form.title')" centered>
    <span>{{ $t('dharma-application-form.message.already-added-to-application-list') }}</span>
    <template #modal-footer="{ close }">
      <b-button class="w-50" variant="default" @click="close()">
        <span
          style="word-break: break-word; white-space: normal; overflow-wrap: break-word;"
          class="d-block d-sm-inline-block"
          v-html="$t('modal.button.continue-browsing.label')"
        ></span>
      </b-button>
      <b-button class="w-50" variant="success" @click="submit">
        {{ $t('modal.button.submit.label') }}
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import Vue from 'vue'

import { ButtonPlugin } from 'bootstrap-vue'
import { ModalPlugin } from 'bootstrap-vue'

import i18n from '@/plugins/i18n.js'

Vue.use(ButtonPlugin)
Vue.use(ModalPlugin)

export default {
  i18n,
  name: 'application-success-message-modal',
  props: {
    id: { type: String, required: true }
  },
  methods: {
    submit() {
      this.$emit('submit')
      this.$bvModal.hide(this.id)
    }
  },
  async created() {
    // alert(`Vue version : ${Vue.version}`)
  }
}
</script>
